var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoneNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "zone_new",
    width: 13,
    height: 13,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAACXBIWXMAAAsSAAALEgHS3X78AAABXklEQVRIie1VPWuDUBQ9VyJVyNCtQyPmJwjdOjl10PyI7FmyhQ5CxuKUqWPInF/QLfkJdXQLWGi3OJX0I75yw7OIJD6bmqm98HgK551zvO/eKwkhcKpoMS8RPQBwAMwAbBRajLsBcC2EeKwC7pwT0Uu73b4YDAYwDKOSeT6fI47jLMuyKxU5ZFruRqORqBOLxULYtv3E51RLkxobleNi6Lr+WQen1cAcHf/kf5k8TVOEYYjtdntJRGMVviV3hzvPdd1KcBAEWK/XmE6nLc/zboloJYSYHcLn7f+qadqZZVnPVQ3CjpmYTfR6vY8oiu6TJBkedCPbn4eRo2pnAGPTNN9833/nowC8SnydGVES6Hc6nQmALoClFOF9WDb4Y/Lyl0jy4lrx6C4OrmNj38hl8sl3zn/hvLvHeb+RtEiBnDQtPLtNkfNlcq1zxeUCy6bI+wDOCyXN97B7P93fH8AX9U8RP+BGD5oAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoneNew);
export default __webpack_public_path__ + "static/media/zone_new.a086a8c3d36479a5a5e1a25b34b4f7f2.svg";
export { ForwardRef as ReactComponent };